import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dr2g2r45g7: FaireBrandEntity = {
  token: "b_dr2g2r45g7",
  type: "brand",
  name: "a.ren",
  avatarUrl:
    "https://cdn.faire.com/fastly/bae182e88337a817af5534d9ab318a38eeb94d85a78452b685389d1c976de6ab.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d3d181a319e302e0b22d22495af71620bb2ce9a0d8765c218de4d9611459ed7f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bae182e88337a817af5534d9ab318a38eeb94d85a78452b685389d1c976de6ab.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d3d181a319e302e0b22d22495af71620bb2ce9a0d8765c218de4d9611459ed7f.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 4.9,
  reviewCount: 15,
  isInsider: true,
  description:
    "a.ren, a premier lifestyle clothing brand, driven by the essence of elevated basics and understated luxury. Designed for individuals in pursuit of timeless beauty.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:47.255Z",
    importedBy: "entity-db-cli",
  },
};
